// frontend/src/utils/numberUtils.js

export const numToWords = (n) => {
  const ones = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
  const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];

  if (n < 20) return ones[n];
  if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? "-" + ones[n % 10] : "");
  if (n < 1000) return ones[Math.floor(n / 100)] + "-hundred" + (n % 100 ? "-" + numToWords(n % 100) : "");
  if (n < 1000000) return numToWords(Math.floor(n / 1000)) + "-thousand" + (n % 1000 ? "-" + numToWords(n % 1000) : "");
  return n;
};